// extracted by mini-css-extract-plugin
export var buttonIcon = "DishSelect-module--buttonIcon--lJZ12";
export var buttonText = "DishSelect-module--buttonText--sgiD2";
export var container = "DishSelect-module--container--F7vE+";
export var content = "DishSelect-module--content--r3x0s";
export var footer = "DishSelect-module--footer--jW3To";
export var header = "DishSelect-module--header--Wsi8N";
export var noProducts = "DishSelect-module--noProducts--S6X0y";
export var qtyButton = "DishSelect-module--qtyButton--fz6yR";